import request from '../../domain/utils/request'
import { WEATHER_PRECISION } from '../../domain/weather/weather.constants'
import { getService } from '../../parameters'
import SERVICES from '../../services.constants'

export const requestWeather = ({ lat, lng }, locale) => {
  const params = {
    lat: (lat ?? 0).toFixed(WEATHER_PRECISION),
    lng: (lng ?? 0).toFixed(WEATHER_PRECISION)
  }
  return request
    .get(getService(SERVICES.WEATHER), { params, locale })
    .then(({ data }) => data)
    .catch(e => {
      console.warn('failed to fetch weather', e)
      return null
    })
}
